import React, { useEffect, useMemo, useState } from "react";
import useInterviewExpiry from "../../../../hooks/useInterviewExpiry";
import Topbar from "../../../Topbar";
import Sidebar from "../../../Sidebar";
import Utils from "../../../../utils/Utils";
import WebUtils from "../../../../utils/WebUtils";
import Loader from "../../../Loader";
import {
  getBlueprintJdDetailsApi,
  getInterviewDataApi,
} from "../../../../api/candidate";
import { Segmented } from "antd";
import IDronaConfig from "./IDronaConfig";
import InterviewState from "./InterviewState";

function ScheduleMainPage() {
  const userDetail = Utils.getUserDetail();

  const queryParams = new URLSearchParams(window.location.search);
  const jdId = queryParams.get("jdIdentifier");
  const iDronaId = queryParams.get("iDronaId");

  const [loading, setLoading] = useState(false);
  const [jdDetails, setJdDetails] = useState(null);
  const [interviewData, setInterviewData] = useState(null);
  const [tab, setTab] = useState("Interview Status");

  const [interviewState, setInterviewState] = useState(null);
  // Flips Scheduled to Expired on screen at the deadline, without a refresh.
  const expiryItems = useMemo(
    () => [{ interviewState, expiresAt: interviewData?.expiresAt }],
    [interviewState, interviewData?.expiresAt]
  );
  const liveInterviewState = useInterviewExpiry(
    expiryItems,
    interviewData?.serverTime
  )(expiryItems[0]);

  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const getJdDetails = () => {
    const url = `${getBlueprintJdDetailsApi}?jdIdentifier=${jdId}&userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result.data);
          setJdDetails(result?.data?.data);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
          setJdDetails(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getInterview = () => {
    const url = `${getInterviewDataApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&iDronaInterviewId=${iDronaId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result.data);
          setInterviewData(result.data.data);
          setInterviewState(result.data.data.interviewState);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
          setInterviewData(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getJdDetails();
    getInterview();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="mock-interview" userRole="candidate" />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="mock-interview"
            userRole="candidate"
            newTitle="Schedule Mock Interview"
            driverFlag="create-new-draft"
          />
          <div className="px-2 mt-4">
            <div className="flex items-center flex-col gap-x-14 gap-y-2 flex-wrap justify-center">
              <span className="font-semibold text-xl text-center">
                Schedule interview for{" "}
                <span className="text-[#EDC043]">{jdDetails?.jobTitle} </span> @
                {jdDetails?.companyName} ({jdDetails?.yearsOfExperience}+ yrs)
              </span>
              <span className="text-[#475467] flex gap-x-4">
                <span className="flex gap-x-2 items-center">
                  <svg
                    width="14"
                    height="17"
                    viewBox="0 0 14 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 8.875C8.24264 8.875 9.25 7.86764 9.25 6.625C9.25 5.38236 8.24264 4.375 7 4.375C5.75736 4.375 4.75 5.38236 4.75 6.625C4.75 7.86764 5.75736 8.875 7 8.875Z"
                      stroke="#667085"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 16C8.5 13 13 11.0637 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 11.0637 5.5 13 7 16Z"
                      stroke="#667085"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  {jdDetails?.jobLocation}
                </span>
                {/* <span className="flex gap-x-2 items-center">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 3.8V8L10.8 9.4M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
                      stroke="#667085"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Created on {formatDate(jdDetails?.creationTime)}
                </span> */}
              </span>
            </div>

            <div className="mt-5 mb-6 orange-segment flex justify-center items-center">
              <Segmented
                options={[
                  {
                    label: "Interview Status",
                    value: "Interview Status",
                  },
                  {
                    label: "iDrona Configuration",
                    value: "iDrona Configuration",
                  },
                ]}
                onChange={(value) => {
                  setTab(value);
                }}
              />{" "}
            </div>
            {tab === "Interview Status" && interviewData && (
              <div className="max-w-[900px] mx-auto">
                <InterviewState
                  setLoading={setLoading}
                  jdDetails={jdDetails}
                  interviewData={interviewData}
                  setInterviewData={setInterviewData}
                  setInterviewState={setInterviewState}
                  interviewState={liveInterviewState}
                  jdId={jdId}
                  iDronaId={iDronaId}
                  userDetail={userDetail}
                />
              </div>
            )}
            {tab === "iDrona Configuration" && (
              <IDronaConfig
                userDetail={userDetail}
                setLoading={setLoading}
                iDronaId={iDronaId}
                jdDetails={jdDetails}
                jdId={jdId}
                interviewState={interviewState}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ScheduleMainPage;
